import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const FontProvider = () => (
    <Global
        styles={`
       /* Continental StagSans LCG Light Regular */
        @font-face {
            font-family: 'ContiStagSans';
            src: url('${getAssetUrl('static/fonts/continental_stag_sans_lcg-light_1-webfont.woff2')}') format("woff2"),
                 url('${getAssetUrl('static/fonts/continental_stag_sans_lcg-light_1-webfont.woff')}') format("woff");
            font-style: normal;
            font-weight: 300;
            font-stretch: normal;
            font-display: swap;
        }
       
       /* Continental StagSans LCG Light Italic */
        @font-face {
            font-family: 'ContiStagSans';
            src: url('${getAssetUrl('static/fonts/continental_stag_sans_lcg-light_italic_1-webfont.woff2')}') format("woff2"),
                 url('${getAssetUrl('static/fonts/continental_stag_sans_lcg-light_italic_1-webfont.woff')}') format("woff");
            font-style: italic;
            font-weight: 300;
            font-stretch: normal;
            font-display: swap;
        }
         
        /* Continental StagSans LCG Book */
        @font-face {
            font-family: 'ContiStagSans';
            src: url('${getAssetUrl('static/fonts/continental_stag_sans_lcg-book-webfont.woff2')}') format("woff2"),
                 url('${getAssetUrl('static/fonts/continental_stag_sans_lcg-book-webfont.woff')}') format("woff");                 
            font-style: normal;
            font-weight: 400;
            font-display: swap;
        }
                
        /* Continental StagSans LCG MD Regular */
        @font-face {
            font-family: 'ContiStagSans';
            src: url('${getAssetUrl('static/fonts/continental_stag_sans_lcg-medium-webfont.woff2')}') format("woff2"),
                 url('${getAssetUrl('static/fonts/continental_stag_sans_lcg-medium-webfont.woff')}') format("woff");                 
            font-style: normal;
            font-weight: 500;
            font-display: swap;
        }
      `}
    />
)

export default FontProvider
